import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Dashboard from '@/pages/Dashboard'
import Projects from '@/pages/Projects'
import ProjectOverview from '@/pages/ProjectOverview'
import NotFound from '@/pages/404'
import store from '@/store'
import TestTypes from "@/pages/TestTypes";
import TestTypeNew from "@/pages/TestTypeNew";
import TestJobNew from "@/pages/TestJobNew";
import TestTypeEdit from "@/pages/TestTypeEdit";
import TestJobEdit from "@/pages/TestJobEdit";
import Export from "@/pages/system/Export";
import Import from "@/pages/system/Import";

Vue.use(Router)

const isAuthenticated = (to, from, next) => {
  const currentUser = store.getters['auth/currentUser'];

  if (currentUser && currentUser.exp > (Date.now()/1000)) {
    next()
    return
  }
  next('/')
}

const ifNotAuthenticated = (to, from, next) => {
  const currentUser = store.getters['auth/currentUser'];
  if (currentUser && currentUser.exp > (Date.now()/1000)) {
    next('/projects')
  } else {
    next()
  }
}

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: isAuthenticated
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects,
      beforeEnter: isAuthenticated
    },
    {
      path: '/project/:projectId',
      name: 'project_overview',
      component: ProjectOverview,
      beforeEnter: isAuthenticated
    },
    {
      path: '/test-types/',
      name: 'test_types',
      component: TestTypes,
      beforeEnter: isAuthenticated
    },
    {
      path: '/test-types/new',
      name: 'test_type_new',
      component: TestTypeNew,
      beforeEnter: isAuthenticated
    },
    {
      path: '/test-types/:testTypeId/edit',
      name: 'test_type_edit',
      component: TestTypeEdit,
      beforeEnter: isAuthenticated
    },
    {
      path: '/project/:projectId/test-job/new',
      name: 'test_job_new',
      component: TestJobNew,
      beforeEnter: isAuthenticated
    },
    {
      path: '/test-job/:testJobId/edit',
      name: 'test_job_edit',
      component: TestJobEdit,
      beforeEnter: isAuthenticated
    },
    {
      path: '/system/export',
      name: 'system_export',
      component: Export,
      beforeEnter: isAuthenticated
    },
    {
      path: '/system/import',
      name: 'system_import',
      component: Import,
      beforeEnter: isAuthenticated
    },
    {
      path: '*',
      component: NotFound
    }
  ],
  mode: 'history',
  linkActiveClass: 'is-active'
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
